var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.545 7.47481L21.337 4.74242L22.0253 5.43163L8.83654 18.34C8.66453 18.5083 8.45622 18.6349 8.22762 18.7101L4.42021 19.9514C4.03632 20.0794 3.61306 19.9797 3.32664 19.6938C3.0439 19.4154 2.94579 18.9995 3.07428 18.624L4.34374 14.8975C4.42178 14.671 4.55099 14.4656 4.72132 14.2972L16.827 2.44929C17.4419 1.85284 18.4194 1.85284 19.0343 2.44929L20.5006 3.8846L19.8124 4.57385L18.346 3.13854C18.1144 2.91462 17.7469 2.91462 17.5153 3.13854L15.8151 4.80254L18.545 7.47481ZM2 20.9998H22V21.9998H2V20.9998ZM5.41054 14.9865C5.34733 15.0481 5.29951 15.1236 5.27097 15.2071L4.00152 18.9336L4.11432 19.0311L7.91982 17.789C8.00529 17.761 8.08315 17.7137 8.14732 17.6507L17.8487 8.15648L15.1189 5.4842L5.41054 14.9865Z",
    fill: "#0E5AA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.bb41fca7034eb88b9a55aaddb2cc188e96919f1932d92ae60a9b7e761d5dad12.svg";
export { ForwardRef as ReactComponent };